module.exports = __webpack_public_path__ + "aeab5d3004580e3f16b8c6b7957dcafa.svg";